/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { WisePayout } from "./Common/WisePayout";

export const protobufPackage = "Reality.Reality.Api";

/** <strong>path=/api/v2/wise/payout/list</strong> */
export interface WisePayoutListResponse {
  payouts: WisePayout[];
}

function createBaseWisePayoutListResponse(): WisePayoutListResponse {
  return { payouts: [] };
}

export const WisePayoutListResponse = {
  encode(message: WisePayoutListResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.payouts) {
      WisePayout.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WisePayoutListResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWisePayoutListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.payouts.push(WisePayout.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WisePayoutListResponse {
    return {
      payouts: globalThis.Array.isArray(object?.payouts) ? object.payouts.map((e: any) => WisePayout.fromJSON(e)) : [],
    };
  },

  toJSON(message: WisePayoutListResponse): unknown {
    const obj: any = {};
    if (message.payouts?.length) {
      obj.payouts = message.payouts.map((e) => WisePayout.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WisePayoutListResponse>, I>>(base?: I): WisePayoutListResponse {
    return WisePayoutListResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WisePayoutListResponse>, I>>(object: I): WisePayoutListResponse {
    const message = createBaseWisePayoutListResponse();
    message.payouts = object.payouts?.map((e) => WisePayout.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
